import React from 'react'
import { OverlayTrigger, Tooltip, Container, Row, Card } from 'react-bootstrap'

const AITeacher = ({ title, data }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="text-start" {...props}>
      為您提供準確、有用的建議，優化社群媒體經營策略，並幫助您應對問題與挑戰。
    </Tooltip>
  )

  let AISuggestionData = data.ai_teacher_advice
    ? data.ai_teacher_advice
    : data.ai_teacher_comment

  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>
      <Container>
        <Row>
          <Card className="aiTeacherCard">{AISuggestionData}</Card>
        </Row>
      </Container>
    </>
  )
}

export default AITeacher
